/**
 * May this case be discussed with anyone outside the firm? (Lloyd, 15 Sep 2026.)
 *
 * He asked for a Consent Y/N field so intake and staff can see at a glance whether an update may go
 * out. The answer is deliberately **not** a boolean: "they said no" and "nobody asked" are different
 * facts, and only the second one is fixed by asking. See `caseConsentSummary.ts` on the server.
 *
 * Every field is optional so a stale API cannot break the case page, per the rule that cost the
 * settings screen once already.
 */

import { StoredConsentRecipient } from '../constants/consentRecipients';

export type CaseConsentAnswer = 'granted' | 'declined' | 'not-asked';

/**
 * Not declared here. This file held its own copy of the recipient union and it was already a
 * version behind the server the day it was written, listing four values that Lloyd's five replaced.
 * The list lives in `constants/consentRecipients.ts`, with the retired values named there.
 */
export type ConsentRecipientDto = StoredConsentRecipient;

export interface CaseConsentDto {
  answer?: CaseConsentAnswer;
  label?: string;
  reason?: string;
  recipients?: ConsentRecipientDto[];
  otherName?: string | null;
  otherRelationship?: string | null;
  acceptedAt?: string | null;
}

export default class CaseConsentApi {
  private static host(): string {
    return process.env.API_HOST?.trim() || window.location.origin;
  }

  static async forCase(ticketGuid: string): Promise<CaseConsentDto> {
    const response = await fetch(
      `${CaseConsentApi.host()}/api/v1/manager/ticket/${ticketGuid}/consent`,
      { credentials: 'include' },
    );
    if (!response.ok) {
      throw new Error('Failed to read the consent for this case');
    }
    return response.json();
  }
}
